import React from 'react';
import { Container } from 'reactstrap';
import { Route, Routes } from 'react-router-dom';
import General from './General';
import { UI_CUSTOMISATION_ROUTES } from './config';
import { DarkModeContext } from "../../../base/context/darkMode";
import UISettings from "./UISettings";
import ThirdPartyServices from "./ThirdPartyServices";
import Emails from "./Emails";
import DynamicWidgets from "./DynamicWidgets";
import AdminPanel from "./AdminPanel";

export default function UICustomisation() {

    return (
        <Container fluid className="content">
            <DarkModeContext.Provider>
                <Routes>
                    <Route
                        path={UI_CUSTOMISATION_ROUTES.GENERAL}
                        element={<General/>}
                    />
                    <Route
                        path={UI_CUSTOMISATION_ROUTES.UI_SETTINGS}
                        element={<UISettings/>}
                    />

                    <Route
                        path={UI_CUSTOMISATION_ROUTES.ADMIN_PANEL}
                        element={<AdminPanel/>}
                    />

                    <Route
                        path={UI_CUSTOMISATION_ROUTES.EMAILS}
                        element={<Emails/>}
                    />

                    {/* OD-7176 | Remove Third party services tab from Admin panel */}
                    {/* <Route
                        path={UI_CUSTOMISATION_ROUTES.THIRD_PARTY_SERVICES}
                        element={<ThirdPartyServices />}
                    /> */}

                    <Route
                        path={UI_CUSTOMISATION_ROUTES.DYNAMIC_WIDGETS}
                        element={<DynamicWidgets />}
                    />
                </Routes>
            </DarkModeContext.Provider>
        </Container>
    );
}